import { useSetRecoilState } from 'recoil';
import { MODAL_KEYS } from '../constants';
import { dataModalState } from '../recoil/modal/data-modal.state';
import { useModal } from './useModal';

export function useDataModal(id: string, name: MODAL_KEYS) {
  const setShareModal = useSetRecoilState(dataModalState);
  const [openModal, closeModal] = useModal(name);

  const open = () => {
    setShareModal((prev) => ({ ...prev, id: id }));
    openModal();
  };
  const close = () => {
    setShareModal((prev) => ({ ...prev, id: '' }));
    closeModal();
  };

  return [open, close];
}
